import {isMobile} from "react-device-detect";
import DesktopMyNotifications from "./DesktopMyNotifications";
import MobileMyNotifications from "./MobileMyNotifications";

export default isMobile ? MobileMyNotifications : DesktopMyNotifications